import { Component, ElementRef, ViewChild } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { Diagnostic } from '@ionic-native/diagnostic';
import { AngularFirestore } from 'angularfire2/firestore';

declare let google;

@Component({
    selector: 'page-map',
    templateUrl: 'map.html',
})
export class MapPage {

    @ViewChild('map') mapElement: ElementRef;
    private map: any;
    private markers: any;
    private userPosition: any;
    private markerInfoWindow: any;
    private directionsDisplay: any;
    private directionsService: any;

    constructor(public geolocation: Geolocation, private alertCtrl: AlertController, private diagnostic: Diagnostic, private db: AngularFirestore) {
        this.markers = [];
        this.markerInfoWindow = new google.maps.InfoWindow();
        this.directionsDisplay = new google.maps.DirectionsRenderer();
        this.directionsService = new google.maps.DirectionsService();
    }

    ionViewDidLoad() {
        this.diagnostic.requestLocationAuthorization()
            .then(res => this.loadMap())
            .catch(err => console.error(err));
        this.loadMap();
    }

    loadMap() {
        var posOptions = {
            enableHighAccuracy: false,
            timeout: 20000,
            maximumAge: 0
        };

        this.geolocation.getCurrentPosition(posOptions).then((position) => {
            this.userPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

            let mapOptions = {
                center: new google.maps.LatLng(40.585691, 22.963619),
                zoom: 15,
                mapTypeId: google.maps.MapTypeId.SATELLITE
            };

            this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
            this.directionsDisplay.setMap(this.map);

            this.createMarker(position.coords.latitude, position.coords.longitude, 'green', 'Είστε εδώ');
            this.loadMarkerData();

        }, (err) => {
            console.log(err);
        });
    }

    loadMarkerData() {
        this.db.doc("other/map markers").valueChanges().subscribe((markers: any) => {
            markers.blue.forEach(element => {
                this.markers.push(element);
                this.createMarker(element.lat, element.lng, "blue", element.name);
            });
            markers.red.forEach(element => {
                this.markers.push(element);
                this.createMarker(element.lat, element.lng, "red", element.name);
            });
            markers.orange.forEach(element => {
                this.markers.push(element);
                this.createMarker(element.lat, element.lng, "orange", element.name);
            });
            markers.yellow.forEach(element => {
                this.markers.push(element);
                this.createMarker(element.lat, element.lng, "yellow", element.name);
            });
            markers.purple.forEach(element => {
                this.markers.push(element);
                this.createMarker(element.lat, element.lng, "purple", element.name);
            });
        });
    }

    createMarker(lat: number, lng: number, markerColor: string, infoText: string) {
        let marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: new google.maps.LatLng(lat, lng),
            icon: 'http://maps.google.com/mapfiles/ms/icons/' + markerColor + '-dot.png'
        });

        this.addInfoWindow(marker, '<b>' + infoText + '</b>');
    }

    addInfoWindow(marker, content) {
        google.maps.event.addListener(marker, 'click', () => {
            this.markerInfoWindow.setContent(content);
            this.markerInfoWindow.open(this.map, marker);
        });
    }

    showDestinations() {
        let destinations = [];

        for (let i = 0; i < this.markers.length; i++) {
            destinations.push({
                type: 'radio',
                label: this.markers[i].name,
                value: i
            })
        }

        let alert = this.alertCtrl.create({
            title: 'Επιλέξτε προορισμό',
            message: 'Παρακαλώ επιλέξτε τον προορισμό για τον οποίο θέλετε να λάβετε οδηγίες.',
            inputs: destinations,
            buttons: [
                {
                    text: 'Ακυρο',
                    role: 'cancel'
                },
                {
                    text: 'Οδηγιες',
                    handler: data => {
                        this.calcRoute(this.markers[data].lat, this.markers[data].lng);
                    }
                }
            ]
        });
        alert.present();
    }

    calcRoute(lat: number, lng: number) {
        let selectedMode = 'DRIVING';
        let request = {
            origin: this.userPosition,
            destination: new google.maps.LatLng(lat, lng),
            travelMode: google.maps.TravelMode[selectedMode]
        };
        this.directionsService.route(request, (response, status) => {
            if (status == 'OK') {
                this.directionsDisplay.setDirections(response);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/map/map.ts